import * as yup from "yup";
import {schemaUtils} from "./schemaRegex";
import {CPSMessages} from "./enumerations";

const {emailRegExp, pawdRegExp} = schemaUtils;

export const forgotPasswordEmailSchema = yup.object().shape({
  email: yup
    .string()
    .required(CPSMessages.ENTEREMAILID)
    .matches(emailRegExp, CPSMessages.ENTERVALIDEMAIL),
});

export const CostCenterVerificationSchema = yup.object().shape({
  costCenterName: yup
    .string()
    .trim()
    .required(CPSMessages.ENTER_COST_CENTER_NAME),
});

export const forgotPasswordAnswerSchema = yup.object().shape({
  securityQuestion1Answer: yup
    .string()
    .trim()
    .required(CPSMessages.FIRST_QUESTION_ANSWER),
  securityQuestion2Answer: yup
    .string()
    .trim()
    .required(CPSMessages.SECOND_QUESTION_ANSWER),
});

export const pwdSchema = yup.object().shape({
  userIdentity: yup.string().trim().required(CPSMessages.PLEASE_ENTER_USER_ID),
  oldPassword: yup.string().required(CPSMessages.ENTER_OLD_PASSWORD),
  newPassword: yup
    .string()
    .required(CPSMessages.ENTER_NEW_PASSWORD)
    .notOneOf([yup.ref("oldPassword"), null], CPSMessages.OLD_NEW_NOT_MATCH)
    .matches(pawdRegExp, CPSMessages.PASSWORD_CRITERIA),
  confirmPassword: yup
    .string()
    .required(CPSMessages.PLEASE_REENTER_PASSOWRD)
    .oneOf([yup.ref("newPassword"), null], CPSMessages.PASSWORD_NOT_MATCH),
});
